import script from "./WarehouseDocumentRowStockInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehouseDocumentRowStockInfo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__